'use client';

import { useDialogContext } from './DialogProvider';
import { PromptOpts } from './types';

export function usePrompt() {
  const { showPrompt } = useDialogContext();
  return showPrompt;
}